
<template>
  <!--投诉原因-->
  <div>
    <!--面包屑-->
    <div class='table-bread'>
      <span class="title">当前位置：</span>
      <a-breadcrumb>
        <span slot="separator" :style="{color: 'red'}">></span>
        <template  v-for="(item, index) of levelList">
          <a-breadcrumb-item @click.native="clickBread(item, index)" :key="index">
            <span v-if="index === levelList.length - 1">{{item.name}}</span>
            <span :style="{ cursor: 'pointer' }" v-else type="link">{{item.name}}</span>
          </a-breadcrumb-item>
        </template>
      </a-breadcrumb>
    </div>

    <x-tabula
      ref="table"
      @resetSearch="resetSearch"
      :dataSource="dataSource"
      :rowOptLen="4"
      rowKey="complaintCategoryId"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
    </x-tabula>
  </div>
</template>

<script>
export default {
  name: 'complainReason',
  data () {
    return {
      levelList: [{ id: '', name: '首页' }],
      searchList: [
        { props: ['title'], placeholder: '投诉原因', options: [], inputType: 'input' },
        { props: ['type'], placeholder: '应用位置', options: [], inputType: 'select' }
      ],
      searchParams: {
        title: undefined,
        type: undefined,
        parentId: undefined
      },
      tableOptList: [{ text: '新增', icon: 'plus', permi: ['community:housekeepComplaintCategory:add'] }],
      rowOptList: [
        {
          text: '查看子类',
          handle: (row) => this.showSubCategory(row),
          rowOptDisHandle: row => row.canSeeChild == 0,
          permi: ['community:housekeepComplaintCategory:query']
        },
        {
          text: '添加子类',
          handle: (row) => this.toAddChild(row),
          rowOptDisHandle: row => row.canAddChild == 0,
          permi: ['community:housekeepComplaintCategory:add']
        },
        {text: '修改', handle: (row) => this.$refs.table.toEdit(row), permi: ['community:housekeepComplaintCategory:edit']},
        {text: '删除', handle: (row) => this.$refs.table.showDeleteConfirm(row), permi: ['community:housekeepComplaintCategory:delete']}
      ],
      columns: [
        { title: '投诉原因', dataIndex: 'title', align: 'left', width: '' },
        { title: '应用位置', dataIndex: 'typeDesc', align: 'left', width: '' },
        { title: '创建时间', dataIndex: 'createTime', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      listApi: {
        url: '/housekeep/complaint/category/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'ncComplainReasonAdd',
        addTitle: '新增投诉',
        editTitle: '修改投诉'
      },
      deleteParam: {
        url: '/housekeep/complaint/category/',
        param: { pk_key: '', pk_val: 'complaintCategoryId' },
        title: '投诉原因',
        key: 'title'
      }
    };
  },
  created () {
    this.getSelect();
  },
  methods: {
    getSelect () {
      this.$get({
        url: '/dict/data/dictType/comu_housekeep_complaint_category_type',
        params: {}
      }).then(({data}) => {
        this.searchList[1].options = data;
      });
    },
    /** 重置搜索 */
    resetSearch () {
      this.levelList.splice(1, this.levelList.length - 1);
    },
    /* 点击面包屑 */
    clickBread (item, index) {
      let len = this.levelList.length;
      if (index === len - 1) {
        return false;
      } else {
        this.levelList.splice(index + 1, len - (index + 1));
        this.resetData(this.searchParams);
        this.searchParams.parentId = item.id;
        this.$refs.table.getTableList();
      }
    },
    /* 查看下级 */
    showSubCategory (row) {
      this.levelList.push({
        id: row.complaintCategoryId,
        name: row.title
      });
      this.resetData(this.searchParams);
      this.searchParams.parentId = row.complaintCategoryId;
      this.$refs.table.getTableList();
    },

    /* 进入添加子类 */
    toAddChild (row) {
      let idArr;
      if (row.parentIds.length) {
        idArr = [...row.parentIds, row.complaintCategoryId].toString();
      } else {
        idArr = row.complaintCategoryId;
      }
      this.$router.push({
        name: 'ncComplainReasonAdd',
        query: {
          parentId: idArr,
          type: row.type,
          title: '添加子类'
        }
      });
    },
    resHandle (res) {
      console.log('处理list返回数据: ');
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>
